import { millisecondsInSecond } from 'date-fns'

export const SEND_EVENT_TIMEOUT = 15 * millisecondsInSecond
